module.exports = __webpack_public_path__ + "static/media/master.236f3baf.png";